import React, { useRef, useEffect } from 'react';

// SVG bee with larger wings and animated flapping effect
const Bee = ({ style = {}, className = '', ...props }) => {
  const leftWingRef = useRef();
  const rightWingRef = useRef();

  useEffect(() => {
    let frame;
    function animate(ts) {
      // Flap frequency: 6 flaps per second
      const t = (ts / 1000) * 6 * Math.PI;
      // Flap amplitude: +/- 18deg
      const angle = Math.sin(t) * 18;
      if (leftWingRef.current) {
        leftWingRef.current.setAttribute('transform', `rotate(${-angle},11,13)`);
      }
      if (rightWingRef.current) {
        rightWingRef.current.setAttribute('transform', `rotate(${angle},27,13)`);
      }
      frame = requestAnimationFrame(animate);
    }
    frame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frame);
  }, []);

  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={className}
      {...props}
    >
      {/* Wings - even larger, animated */}
      <ellipse ref={leftWingRef} cx="11" cy="13" rx="10" ry="5.5" fill="#B3E5FC" opacity="0.7" />
      <ellipse ref={rightWingRef} cx="27" cy="13" rx="10" ry="5.5" fill="#B3E5FC" opacity="0.7" />
      {/* Body */}
      <ellipse cx="19" cy="22" rx="10" ry="13" fill="#F63040" stroke="#57565B" strokeWidth="2"/>
      {/* Stripes */}
      <rect x="11" y="13" width="16" height="3" rx="1.5" fill="#57565B"/>
      <rect x="11" y="19" width="16" height="3" rx="1.5" fill="#57565B"/>
      <rect x="11" y="25" width="16" height="3" rx="1.5" fill="#57565B"/>
      {/* Head */}
      <circle cx="19" cy="10" r="6" fill="#fff" stroke="#57565B" strokeWidth="2"/>
      {/* Eyes */}
      <circle cx="17" cy="11" r="1.2" fill="#57565B"/>
      <circle cx="21" cy="11" r="1.2" fill="#57565B"/>
      {/* Antennae */}
      <path d="M16 5 Q15 2 13 3" stroke="#57565B" strokeWidth="1.2" fill="none"/>
      <path d="M22 5 Q23 2 25 3" stroke="#57565B" strokeWidth="1.2" fill="none"/>
      {/* Stinger */}
      <polygon points="19,35 21,38 17,38" fill="#57565B"/>
    </svg>
  );
};

export default Bee;
